"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityMetrics = void 0;
var IntentDetectionRate_1 = require("./IntentDetectionRate");
var TopExecutedBehaviour_1 = require("./TopExecutedBehaviour");
var BehaviourState_1 = require("./BehaviourState");
var MetricsEntityCount_1 = require("./MetricsEntityCount");
/**
 * Represents identity metrics information
 */
var IdentityMetrics = /** @class */ (function (_super) {
    __extends(IdentityMetrics, _super);
    function IdentityMetrics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "IdentityMetrics";
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        _this.entityCount = function (config) { return _this.push(function (registry) {
            var entity = new MetricsEntityCount_1.MetricsEntityCount();
            config(entity);
            return "entityCount { " + entity.render(registry) + " }";
        }); };
        _this.topExecutedBehaviours = function (config) { return _this.push(function (registry) {
            var entity = new TopExecutedBehaviour_1.TopExecutedBehaviour();
            config(entity);
            return "topExecutedBehaviours { " + entity.render(registry) + " }";
        }); };
        _this.behaviourStates = function (config) { return _this.push(function (registry) {
            var entity = new BehaviourState_1.BehaviourState();
            config(entity);
            return "behaviourStates { " + entity.render(registry) + " }";
        }); };
        _this.intentDetectionRate = function (config) { return _this.push(function (registry) {
            var entity = new IntentDetectionRate_1.IntentDetectionRate();
            config(entity);
            return "intentDetectionRate { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return IdentityMetrics;
}(Array));
exports.IdentityMetrics = IdentityMetrics;
//# sourceMappingURL=IdentityMetrics.js.map